// in src/index.js
/* global wp, TagColor */

// Added lines to use wp.element instead of importing React
const { Component } = wp.element;
import { fetchPosts } from "./api";
import { fetchTag } from "./api";

class TvBlog extends Component {     // instead of: ...extends React.Component
	constructor(props) {
		super(props);
		this.state = {
			blogs: null,
			featuredPost: null,
			tags: null,
			page: 1,
		};
	}

	async _loadBlogPosts() {
		this.setState({
			blogs: await fetchPosts()
		});
	}

	async _loadTags() {
		this.setState({
			tags: await fetchTag()
		});
	}

	async componentDidMount() {
		this._loadBlogPosts();
		this._loadTags();
	}

	_genTag(tag) {
		if (tag != null && tag.length > 0) {
			return (
				<div className="tag">
					{tag[0].name}
				</div>
			);
		}
	}

	async _fetchTags(post) {
		//history.pushState({}, null, `https://mrlarbin.fr/blog/?cat=?${post.name}`);
		const nextURL = window.location.origin + "/blog/?cat=?" + post.name;
		//const nextTitle = `Boutique Mr Larbin`;
		const nextState = { additionalInformation: "Updated the URL with JS" };

		window.history.pushState(nextState, null, nextURL);
		this.setState({
			page: this.state.page,
			blog: []
		}, () => this._fetchProducts());
	}

	_refresh() {
		this.setState({
			page: 1,
			blog: []
		}, () => this._fetchTags());
	}

	_genPost(post) {
		if (post) {
			return (
				<div className="post">
					<div className="image-container">
						<img src={post.jetpack_featured_media_url} />
					</div>
					<div className="post-data">
						{this._genTag(post.mtags)}
						<h2>{post.title.rendered}</h2>
						<span className="post-desc" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}></span>
					</div>
				</div>
			);
		}
	}

	_genColorTags(post){
		let res = null;
		res = TagColor.find(x => x.tag == post.id );
		if (res != null) return (res.couleur);
		return ("#aeaeae");
	}

	_genTagsBox(post) {
		if (post) {
			return (
				<div>
					<a className="box-tag"
						onClick={() => this._fetchTags(post)}
						style={{ backgroundColor: this._genColorTags(post)}}>{post.name}</a>
				</div>
			);
		}
	}

	_genFeaturedPost(featuredPost) {
		if (featuredPost != null) {
			return (
				<div id="featured-post">
					{this._genPost(featuredPost)}
				</div>
			);
		}
	}

	_genContent() {
		if (this.state.blogs != null) {
			return (this.state.blogs.map(blog => this._genPost(blog)));
		}
	}

	_genTags() {
		if (this.state.tags != null) {
			return (this.state.tags.map(tags => this._genTagsBox(tags)));
		}
	}

	_genCategories(categories) {
		if (categories != null) {
			return (
				categories.map((category, index) => {
					return (
						<div key={index} className="tag tag-link">
							{category}
						</div>
					);
				})
			);
		}
	}

	render() {
		return (
			<div>
				<h1 id="blog-title"><span>Blog</span></h1>
				<div id="blog-content">
					{this._genFeaturedPost(this.state.blogs != null ? this.state.blogs[0] : null)}
					<div id="posts">
						{this._genContent()}
					</div>
				</div>
				<hr />
				<div id="blog-categories">
					{this._genCategories()}
				</div>
				<div id="blog-tags">
					{this._genTags()}
					{console.log(this.state.blogs, "blogs1")}
					{console.log(this.state.tags, "tags2")}
				</div>
			</div>
		);
	}
}

export default TvBlog;